import {
  SET_BILLING_CALCULATION,
  CLEAR_BILLING_CALCULATION,
} from '../../constants';

export const setBillingCalculation = (billingCalculation, appliedPromoCode) => ({
  type: SET_BILLING_CALCULATION,
  payload: {
    billingCalculation,
    appliedPromoCode,
  },
});

export const clearBillingCalculation = () => ({
  type: CLEAR_BILLING_CALCULATION,
});
